"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { MapPin, Clock, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function TastingInformation() {
  return <section id="información-de-las-catas" className="section bg-background px-4 sm:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {}
          <div className="flex flex-col gap-6">
            <div>
              <h2 className="font-serif text-4xl lg:text-5xl font-medium text-foreground mb-4">
                Qué incluye la cata
              </h2>
              <p className="font-sans text-muted-foreground text-lg leading-relaxed">
                Nuestras catas son una experiencia sensorial completa diseñada
                para descubrir la esencia de nuestro aceite de oliva virgen
                extra.
              </p>
            </div>

            <Card className="border-transparent shadow-none bg-muted/30">
              <CardHeader>
                <CardTitle className="font-serif text-xl font-medium text-foreground">
                  Historia y tradición
                  </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-sans text-muted-foreground leading-relaxed">
                  Conocerás la historia familiar detrás de Aceite Paco y
                  Herminia, el proceso de elaboración desde el olivar hasta la
                  botella, y nuestro compromiso con la sostenibilidad y la
                  trazabilidad.
                </p>
              </CardContent>
            </Card>

            <Card className="border-transparent shadow-none bg-muted/30">
              <CardHeader>
                <CardTitle className="font-serif text-xl font-medium text-foreground">
                  Análisis sensorial
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-sans text-muted-foreground leading-relaxed">
                  Aprenderás a identificar los atributos del aceite: aroma,
                  sabor, textura y retrogusto. Realizarás una degustación
                  guiada para reconocer las notas características de nuestro
                  aceite equilibrado y auténtico.
                </p>
              </CardContent>
            </Card>

            <Card className="border-transparent shadow-none bg-muted/30">
              <CardHeader>
                <CardTitle className="font-serif text-xl font-medium text-foreground">
                  Maridaje con alimentos
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-sans text-muted-foreground leading-relaxed">
                  Descubrirás cómo nuestro aceite realza los sabores de
                  diferentes alimentos: pan artesanal, tomate, queso y otros
                  productos mediterráneos. Ideal tanto para la cocina diaria
                  como para platos gourmet.
                </p>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <div>
              <h2 className="font-serif text-4xl lg:text-5xl font-medium text-foreground mb-4">
                Información práctica
              </h2>
              <p className="font-sans text-muted-foreground text-lg leading-relaxed">
                Todo lo que necesitas saber para unirte a nuestras catas en La
                Haya.
              </p>
            </div>

            <Card className="border-transparent shadow-none bg-muted/30">
              <CardContent className="pt-6">
                <Table>
                  <TableBody>
                    <TableRow className="border-border/50">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <MapPin className="size-5 text-accent" />
                        Ubicación
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">
                        Centro Español, La Haya, Países Bajos
                      </TableCell>
                    </TableRow>
                    <TableRow className="border-border/50">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <Clock className="size-5 text-accent" />
                        Duración
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">
                        90 minutos
                      </TableCell>
                    </TableRow>
                    <TableRow className="border-border/50">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <Users className="size-5 text-accent" />
                        Precio
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">15 euro p.p.&nbsp;</TableCell>
                    </TableRow>
                    <TableRow className="border-border/50">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <MapPin className="size-5 text-accent" />
                        Qué incluye
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">
                        2 bebidas, una tapa y degustación de nuestros aceites de oliva virgen extra.
                      </TableCell>
                    </TableRow>
                    <TableRow className="border-border/50">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <Users className="size-5 text-accent" />
                        Número máximo de visitantes
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">
                        10 personas.
                      </TableCell>
                    </TableRow>
                    <TableRow className="border-border/50">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <Clock className="size-5 text-accent" />
                        Cuándo
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">
                        Cada último jueves del mes.
                      </TableCell>
                    </TableRow>
                    <TableRow className="border-0">
                      <TableCell className="font-sans font-medium text-foreground flex items-center gap-2">
                        <MapPin className="size-5 text-accent" />
                        Ubicación
                      </TableCell>
                      <TableCell className="font-sans text-muted-foreground">
                        Centro Español – La Haya Korte Lombardstraat 6, Den Haag, Países Bajos.
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </CardContent>
            </Card>

            <div className="bg-muted/50 rounded-xl p-8 space-y-4">
              <h3 className="font-serif font-medium text-2xl text-foreground">
                Reserva tu plaza
              </h3>
              <p className="font-sans text-muted-foreground text-base leading-relaxed">
                Las plazas son limitadas. Contáctanos para conocer las próximas
                fechas y asegurar tu participación en esta experiencia única.
              </p>
              <Link to="/#contacto">
                <Button className="btn w-full sm:w-auto">
                  Contactar para reservar
                </Button>
              </Link>
            </div>

            <div className="bg-muted/20 rounded-xl p-8">
              <p className="font-sans text-sm text-muted-foreground leading-relaxed">
                <strong className="text-foreground font-semibold">Nota importante:</strong>{" "}
                Durante las catas, los particulares pueden adquirir nuestro
                aceite directamente. No vendemos online, trabajamos
                exclusivamente con tiendas delicatessen, tiendas gourmet y
                distribuidores.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}